import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import GenericTable from "../../GenericTable/GenericTable";
import TableToolbar from "../..//GenericTable/TableToolbar";
import WorkflowSidebar from "../../workflowActions/WorkflowSidebar";
import { enhanceColumns } from "./enhanceWorkflow.data";
import { useDispatch, useSelector } from "react-redux";
import {
  exportEnhanceWorkflowCSV,
  getCodeEnhanceWorkflowViewData,
  getEnhanceAuditResults,
  getEnhancePlusFlags,
  getEnhanceWorkflowEpisodeDetails,
  initialPayload,
  REQUEST_STATUS,
  resetEpisodeReviewData,
  resetPayload,
  resetResponse,
  setPayload,
  unassignEpisode,
} from "./EnhanceWorkflowSlice";
import EpisodeReview from "../EpisodeReview/EpisodeReview";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getSelectedAuditedFilesMenuData,
  setSelectedFileIds,      
  removeSelectedFileId,    
  clearSelectedFileIds
 } from "../../SelectFilesMenu/SelectFilesMenuSlice";
import { toast } from "react-toastify";
import EnhanceWorkflowFilterModal from "./EnhanceWorkflowFilter/EnhanceWorkflowfilter";
import { cleanJoin, downloadBlob } from "../../../web-workflow/utils/util";

export default function EnhanceWorkflow({ activeModule, onModuleChange }) {
  const [sidebarSelected, setSidebarSelected] = useState("");
  const [hiddenColumnGroups, setHiddenColumnGroups] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const preferredColumnGroups = [...new Set(enhanceColumns.map((column) => column.group).filter(Boolean))]
    .map((name) => ({ name, visible: !hiddenColumnGroups.includes(name), children: enhanceColumns.filter((column) => column.group === name).map((column) => ({ ...column, visible: !hiddenColumns.includes(column.field) })) }));
  const visibleColumns = enhanceColumns.filter((column) => (!column.group || !hiddenColumnGroups.includes(column.group)) && !hiddenColumns.includes(column.field));
  const toggleColumnGroup = (name) => setHiddenColumnGroups((groups) => groups.includes(name) ? groups.filter((group) => group !== name) : [...groups, name]);
  const toggleColumn = (field) => setHiddenColumns((fields) => fields.includes(field) ? fields.filter((item) => item !== field) : [...fields, field]);
  const [search, setSearch] = useState("");
  // const [selectedFileIds, setSelectedFileIds] = useState([]);
  const [view, setView] = useState("list");
  const [selectedEpisode, setSelectedEpisode] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const currentUserId = sessionStorage.getItem("userId");
  const [openFilter, setOpenFilter] = useState(false);
  const [isRecalledView, setIsRecalledView] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isUnassignedView, setIsUnassignedView] = useState(false);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [pageSizeReady, setPageSizeReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { episodeId } = useParams();
  const [searchType, setSearchType] = useState("episode");

  // Use ref to track initial mount
  const isFirstRender = useRef(true);
  const previousPayloadRef = useRef(null);

  const { data, status } = useSelector(
    (state) => state.selectedAuditedFiles.files,
  );
   const selectedFileIds = useSelector(
   (state) => state.selectedAuditedFiles.selectedFileIds,
  );

  const { payload, response, episodeDetails, plusFlags, auditResults, assign } =
    useSelector((state) => state.codeEnhance);

  const pagination = response?.data?.pagination || {};
  const currentPage = (pagination.page_number || 1) - 1;
  const totalPages = pagination.total_pages || 1;

  const tableLoading = response.status === REQUEST_STATUS.LOADING;
  const apiRows = response?.data?.data?.audited_rows ?? [];
const FILTER_BOOKKEEPING_KEYS = [
  "page_number",
  "page_size",
  "unassigned_page",
  "is_flagged",
  "sort_by",
  "sort_order",
  "is_global",  
  "recall",
];
const files = data.map((item) => ({
    id: item.header_id,
    fileName: item.file_name?.join(", ") || "",
    dateRange: `${item.start_date} - ${item.end_date}`,
    loadId: item.load_id,
    total_records: item.total_records
  }));

  const selectedFileNames = files
    .filter((file) => selectedFileIds.includes(file.id))
    .map((file) => file.fileName);
const hasActiveFilters = Object.entries(payload).some(([key, value]) => {
  if (FILTER_BOOKKEEPING_KEYS.includes(key)) return false;
  if (value === undefined || value === null || value === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === "boolean") return false;
  return true;
});

  const enhanceRows = apiRows.map((item) => ({
    priority: item.priority_value,
    episodeId: item.episode_identifier,
    hcpLineId: item.hcp_line_id,
    mrn: item.ur_number,
    dob: item.date_of_birth,
    age: item.age,
    sex: item.sex,
    admitDate: item.admit_date,
    speciality:item.case_mix_speciality,
    dischargeDate: item.discharge_date,
    los: item.length_of_stay,
    diagnosis: item.principal_diagonsis,
    currentDrg: item.drg,
    drgVersion: item.drg_version,
    auditStatus: item.status,
    auditRuleCategory: item.audit_rule_category,
    auditRuleRefNo: item.audit_ref_no?.join(", "),
    auditShortDescription: item.audit_rule_short_description?.join(", ") || "",
    auditLongDescription:item.long_description?.join(", ") || "",
    auditUserMessage:item.user_message.join(", "),
    episodeFailedMultipleRules:item.episode_failed_multiple_rules?"Yes":"No",
    sourceofReferral:item.source_of_referral,
    modeofSeparation:item.mode_of_separation,
    additionalDiagnosis: cleanJoin(item.additional_diagnoses),
    procedureDiagnosis: cleanJoin(item.procedure_codes),
    loadID:item.load_id,
    createdAt:item.hcp_line_created_at,
    currentDrgRevenue:
      typeof item.current_drg_revenue === "string"
        ? item.current_drg_revenue.trim() || "-------"
        : (item.current_drg_revenue ?? "-------"),
    auditDrgRevenue:
      typeof item.audit_drg_revenue === "string"
        ? item.audit_drg_revenue.trim() || "-------"
        : (item.audit_drg_revenue ?? "-------"),
    healthFund: item.health_fund,
    hospitalType: item.hospital_type,
    careType: item.care_type,
    fileName: item.file_name,
    coderName: item.coder_name,
    isDrgDifferent: item.is_drg_different ? "Yes" : "No",
    assignedTo:item.assigned_to_user_name
  }));

const handlePageChange = (page) => {
  dispatch(
    setPayload({
      page_number: page + 1,
      page_size: payload.page_size || 10,   // CHANGED — don't clobber the dynamic size
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
};
const handlePageSizeChange = (newSize) => {
  setPageSizeReady(true); // NEW — unblocks the fetch effect below
  if (newSize === payload.page_size) return; // avoid a no-op dispatch
  dispatch(
    setPayload({
      page_size: newSize,
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
};

  // useEffect(() => {
  //   if (assign.status === REQUEST_STATUS.SUCCESS)
  //     toast.success("Assigned successfully");
  // }, [assign.status]);
useEffect(() => {
  if (!pageSizeReady) return;

  if (isFirstRender.current) {
    isFirstRender.current = false;
    dispatch(getCodeEnhanceWorkflowViewData(payload));
    previousPayloadRef.current = payload;
    return;
  }

  const payloadChanged =
    JSON.stringify(previousPayloadRef.current) !== JSON.stringify(payload);

  if (payloadChanged) {
    dispatch(getCodeEnhanceWorkflowViewData(payload));
    previousPayloadRef.current = payload;
  }
}, [dispatch, payload, pageSizeReady]);

  const handleFilesApply = (ids) => {
    // setSelectedFileIds(ids);
    dispatch(setSelectedFileIds(ids));
    const selectedFiles = files.filter((file) => ids.includes(file.id));
    dispatch(
      setPayload({
        header_id: selectedFiles.map((file) => file.id),
        file_type: selectedFiles.map((file) => file.fileName),
        page_number: 1,
        unassigned_page: isUnassignedView, 
        is_flagged: isRecalledView, 
         recall:isRecalledView
      }),
    );
  };

  useEffect(() => {
  dispatch(getSelectedAuditedFilesMenuData({ pageNumber: 1, search: "" }));
}, [dispatch]);

useEffect(() => {
  if (selectedFileIds.length === 0) return;
  dispatch(
    setPayload({
      header_id: selectedFileIds,
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
}, [selectedFileIds]);

const filteredRows = search
  ? enhanceRows.filter((r) => {
      const field = searchType === "mrn" ? r.mrn : r.episodeId;
      return field?.toLowerCase().includes(search.toLowerCase());
    })
  : enhanceRows;

  const handleSortChange = ({ field, order }) => {
    dispatch(
      setPayload({
        sort_by: field,
        sort_order: order.toUpperCase(),
        page_number: 1,
        unassigned_page: isUnassignedView, 
        is_flagged: isRecalledView, 
         recall:isRecalledView
      }),
    );
  };

const handleGlobalSearch = (value, type = "episode") => {
  setSearch(value);
  setSearchType(type); 

  dispatch(
    setPayload({
      episode_identifier: type === "episode" && value ? [value] : [],
      medical_record_number: type === "mrn" && value ? [value] : [],
      is_global: Boolean(value),
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
    }),
  );
};

  const handleDownload = async () => {
    const { page_number, page_size, ...exportPayload } = payload;
    setIsDownloading(true);
    try {
      const response = await dispatch(
        exportEnhanceWorkflowCSV(exportPayload),
      ).unwrap();
      const fileUrl = response?.data?.file_url;
      const Querymessage = response?.data?.message;
      toast.success(Querymessage);
      if (fileUrl) {
        // console.log(fileUrl, "acess the url");

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "auditfile.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("file URL not found in reposne");
      }
    } catch (err) {
      toast.error(err || "Failed to export CSV");
    } finally {
      setIsDownloading(false);
    }
  };
  const handleAssignSuccess = () => {
  if (sidebarSelected === "Unassigned Episodes") {
    dispatch(
      getCodeEnhanceWorkflowViewData({
        ...payload,
        unassigned_page: true,
      }),
    );
  } else if (sidebarSelected === "Recalled Episodes") {
    dispatch(
      getCodeEnhanceWorkflowViewData({
        ...payload,
        is_flagged: true,
        recall:true
      }),
    );
  } else {
    dispatch(getCodeEnhanceWorkflowViewData(payload));
  }

  handleBackToList();
};
  const handleUnassignConfirm = async (reason) => {
    const hcpLineId = selectedEpisode?.hcpLineId;
    if (!hcpLineId) {
      toast.error("Missing episode reference");
      return;
    }

    try {
      const res = await dispatch(
        unassignEpisode({
          hcp_lines: [hcpLineId],
          unassigned_by: Number(currentUserId),
          unassignment_reason: reason,
          select_all: false,
          user_id: currentUserId,
          filter: payload,
        }),
      ).unwrap();

      toast.success(res?.message || "Episode unassigned successfully");
        if (sidebarSelected === "Unassigned Episodes") {
    dispatch(
      getCodeEnhanceWorkflowViewData({
        ...payload,
        unassigned_page: true,
      }),
    );
  } else if (sidebarSelected === "Recalled Episodes") {
    dispatch(
      getCodeEnhanceWorkflowViewData({
        ...payload,
        is_flagged: true,
        recall:true
      }),
    );
  } else {
    dispatch(getCodeEnhanceWorkflowViewData(payload));
  }

  handleBackToList();
    } catch (err) {
      toast.error(err || "Something went wrong");
      throw err;
    }
  };

  const handleEpisodeClick = (row) => {
    navigate(`/Review-Enhance-Workflow/${row.hcpLineId}`);
    setSelectedEpisode(row);
    dispatch(getEnhanceWorkflowEpisodeDetails(row.hcpLineId));
    dispatch(getEnhancePlusFlags(row.hcpLineId));
    dispatch(getEnhanceAuditResults(row.hcpLineId));
    // setView("review");
  };
useEffect(() => {
  if (!episodeId) {
    setView("list");
    setSelectedEpisode(null);
    return;
  }

  setSelectedEpisode({ hcpLineId: episodeId });
  dispatch(getEnhanceWorkflowEpisodeDetails(episodeId));
  dispatch(getEnhancePlusFlags(episodeId));
  dispatch(getEnhanceAuditResults(episodeId));
  setView("review");
}, [episodeId, dispatch]);

  const handleBackToList = () => {
    navigate("/Review-Enhance-Workflow"); 
    setView("list");
    setSelectedEpisode(null);
    dispatch(resetEpisodeReviewData());
  };

  if (view === "review") {
    return (
      <Box sx={{ height: "calc(95vh - 14px)", pt: 1.5, bgcolor: "#eef1f5" }}>
        <EpisodeReview
          data={episodeDetails?.data?.data}
          onBack={handleBackToList}
          plusFlags={plusFlags}
          auditResults={auditResults.data}
          activeModule={activeModule}
          onUnassign={handleUnassignConfirm}
          loading={episodeDetails.status === REQUEST_STATUS.LOADING}
          error={
            episodeDetails.status === REQUEST_STATUS.FAILURE
              ? episodeDetails.error || "Something went wrong"
              : null
          }
          hideUnassign={sidebarSelected === "Unassigned Episodes"} 
          onAssignSuccess={handleAssignSuccess} 
        />
      </Box>
    );
  }
  const handleEnhanceRefresh = () => {
    // setSelectedFileIds([]);
    dispatch(clearSelectedFileIds());
    setSearch(""); 
    dispatch(resetPayload());
    dispatch(
    setPayload({
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall:isRecalledView
    }),
  );
    setFilterResetKey((k) => k + 1);
  };
  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 12px)",
        overflow: "hidden",
        pt: 1.5,
        // bgcolor: "#eef1f5",
      }}
    >
      <WorkflowSidebar
        preferredColumnGroups={preferredColumnGroups}
        onTogglePreferredColumnGroup={toggleColumnGroup}
        onTogglePreferredColumn={toggleColumn}
        selected={sidebarSelected}
        onSelect={setSidebarSelected}
        setSidebarSelected={setSidebarSelected}
        sidebarSelected= {sidebarSelected}
        selectedRows={selectedRows}
        activeModule={activeModule}
        onModuleChange={onModuleChange}
        isRecalledView={isRecalledView}
        setIsRecalledView={setIsRecalledView}
        isSelectAll={isSelectAll}
        isUnassignedView={isUnassignedView}
         setIsUnassignedView = {setIsUnassignedView}
        onAssignComplete={() => {
          setSelectedRows([]);
          setIsSelectAll(false);
        }}
      />

      <Box
        sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}
      >
        <TableToolbar
          activeModule={activeModule}
          onModuleChange={onModuleChange}
          onSearch={handleGlobalSearch}
          showVersionInfo={false}
          files={files}
          selectedFileIds={selectedFileIds}
          onFilesApply={handleFilesApply}
          filesLoading={false}
          onFilterClick={() => setOpenFilter(true)}
          onDownload={handleDownload}
          downloadLoading={isDownloading}
          isUnassignedView={isUnassignedView}
         setIsUnassignedView = {setIsUnassignedView}
         isRecalledView={isRecalledView}
        setIsRecalledView={setIsRecalledView}
        setSidebarSelected={setSidebarSelected}
          onRefresh={handleEnhanceRefresh}
           hasActiveFilters={hasActiveFilters}
           selectedFileNames={selectedFileNames}

        />

        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            "& .MuiPaper-elevation0": {
              height: "calc(100vh - 110px)",
            },
          }}
        >
          <GenericTable
            activeModule={activeModule}
            columns={visibleColumns}
            rows={filteredRows}
            loading={tableLoading}
            selectable
            serverMode
            currentPage={currentPage}
            totalPages={totalPages}
            selectedRows={selectedRows}
            onSortChange={handleSortChange}
            onRowClick={handleEpisodeClick}
            onSelectionChange={setSelectedRows}
            onPageChange={handlePageChange}
            isSelectAll={isSelectAll}
            onSelectAllChange={setIsSelectAll}
            filterResetKey={filterResetKey}
              rowsPerPage={payload.page_size || 10}
            onPageSizeChange={handlePageSizeChange}
          />
        </Box>
      </Box>
      <EnhanceWorkflowFilterModal
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        isUnassignedView={isUnassignedView}
        isRecalledView={isRecalledView}
      />
    </Box>
  );
}
